module.exports = __webpack_public_path__ + "static/img/head4.294b95f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head4.png
// module id = UV5y
// module chunks = 1